import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, Target } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const QuickActions: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="bg-white p-6 rounded-xl shadow-sm">
      <h2 className="text-lg font-semibold mb-4">{t('dashboard.quickActions')}</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <button
          onClick={() => navigate('/promoters')}
          className="p-6 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 text-white group"
        >
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center mb-3 group-hover:bg-opacity-30 transition-all">
              <Users className="w-6 h-6 text-white" />
            </div>
            <span className="text-lg font-semibold">{t('dashboard.addPromoter')}</span>
            <span className="text-sm text-green-100 mt-1">{t('dashboard.quickAction.managePromoters')}</span>
          </div>
        </button>
        <button
          onClick={() => navigate('/prospects')}
          className="p-6 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 text-white group"
        >
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center mb-3 group-hover:bg-opacity-30 transition-all">
              <Target className="w-6 h-6 text-white" />
            </div>
            <span className="text-lg font-semibold">{t('dashboard.newProspect')}</span>
            <span className="text-sm text-blue-100 mt-1">{t('dashboard.quickAction.addProspectsToPipeline')}</span>
          </div>
        </button>
      </div>
    </div>
  );
};

export default QuickActions;